import { ArrowUpRight, Youtube } from "lucide-react";
import { SITE } from "../content/site";
import { Reveal } from "./Motion";

export default function SpeakingVideos() {
  return (
    <section data-testid="speaking-videos-section" className="mx-auto max-w-4xl px-6 pb-20 lg:px-10">
      <Reveal>
        <div className="flex flex-col items-center rounded-lg border border-gold/40 bg-gold/[0.04] px-8 py-14 text-center">
          <h2 className="font-mono text-xs uppercase tracking-[0.28em] text-gold">
            Speaking Videos — Watch Now
          </h2>
          <p className="mt-5 max-w-2xl font-serif text-xl italic leading-snug text-[#F9F8F6]/85">
            Explore Kevin’s speaking videos and teaching sessions on leadership, purpose, faith,
            and pressing through life’s challenges. Watch now and discover practical insights to
            help you move forward with intention.
          </p>
          <div className="mt-8 flex flex-col items-center gap-4 sm:flex-row">
            <a
              data-testid="watch-kevin-videos-btn"
              href={SITE.youtubeUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 rounded-full bg-gold px-7 py-3.5 text-sm font-semibold uppercase tracking-[0.08em] text-night transition-colors duration-300 hover:bg-goldlight"
            >
              <Youtube className="h-4 w-4" />
              Watch Videos
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </a>
            <button
              data-testid="invite-kevin-btn"
              onClick={() => document.getElementById("enquire")?.scrollIntoView({ behavior: "smooth" })}
              className="inline-flex items-center rounded-full border border-gold/50 px-7 py-3.5 text-sm font-semibold uppercase tracking-[0.08em] text-gold transition-colors duration-300 hover:border-gold hover:bg-gold/10"
            >
              Invite Kevin to Speak
            </button>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
